import { $createNodeSelection, $getAdjacentNode, $getSelection, $isDecoratorNode, $isRangeSelection, $setSelection, COMMAND_PRIORITY_HIGH, DELETE_CHARACTER_COMMAND, } from 'lexical';
/**
 * Works around a Lexical bug where an isolated decorator node on its own cannot
 * be backspaced/deleted through. The first deletion selects an adjacent isolated
 * decorator node; the next deletion falls through to RichTextPlugin and removes it.
 */
export function deleteCharacterCommand(editor) {
    return editor.registerCommand(DELETE_CHARACTER_COMMAND, (isBackward) => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection) || !selection.isCollapsed()) {
            return false;
        }
        // Let Lexical resolve text, element, and nested-boundary points consistently. Reimplementing
        // this with sibling checks is ambiguous between adjacent decorator nodes.
        return selectIfIsolatedNode($getAdjacentNode(selection.anchor, isBackward));
    }, COMMAND_PRIORITY_HIGH);
}
function selectIfIsolatedNode(node) {
    if (!node || !$isDecoratorNode(node) || !node.isIsolated()) {
        return false;
    }
    const selection = $createNodeSelection();
    selection.add(node.getKey());
    $setSelection(selection);
    return true;
}
//# sourceMappingURL=deleteCharacterCommand.js.map